module.exports = __webpack_public_path__ + "static/media/cartagena-5.fb50cb59.jpg";